module.exports = __webpack_public_path__ + "static/media/kiki.68ba7071.jpg";